import { AnyAction } from 'redux';

import BreadcrumbItem from '../api/breadcrumbItem';
import BreadcrumbsPath from '../api/breadcrumbsPathEntity';
import { actionTypes } from '../common/constants/actionTypes';

export interface IBreadcrumbState {
  breadcrumbItems: BreadcrumbItem[];
  latestPageTitle: string;
  nextRouteLocationPathname: string;
};

const initialState: IBreadcrumbState = {
  breadcrumbItems: [],
  latestPageTitle: '',
  nextRouteLocationPathname: '',
};

const BASE = (): BreadcrumbItem => ({ id: '1', title: 'Etusivu', navigationUrl: '/' });

const isBreadcrumbsPath = (p: any): p is BreadcrumbsPath =>
  p && typeof p === 'object' &&
  (('latestPageTitle' in p) || ('title' in p)) &&
  ('relativePath' in p);

// Build breadcrumb list as BreadcrumbItem[]
function buildPathList(node: BreadcrumbsPath): BreadcrumbItem[] {
  const stack: BreadcrumbsPath[] = [];
  let cur: BreadcrumbsPath | undefined = node;

  while (cur) {
    // push only meaningful nodes; skip empties coming from CMS
    const hasTitle = !!(cur as any).title;
    const hasPath  = !!(cur as any).relativePath;
    if (hasTitle && hasPath) {
      stack.unshift(cur); // root first
    }
    cur = (cur as any).parentBredcrumbsItem;
  }

  let id = 2;
  return [
    BASE(),
    ...stack.map(n => ({
      id: String(id++),
      navigationUrl: (n as any).relativePath,
      title: (n as any).title,
    })),
  ];
}

export const breadcrumbItemsReducer = (
  state: IBreadcrumbState = initialState,
  action: AnyAction
): IBreadcrumbState => {
  switch (action.type) {
    case actionTypes.SET_TOP_NAVIGATION_ACTIVE_CSS: {
      const path = String(action.payload || '');
      const map: { [k: string]: string } = {
        '/ajankohtaista': 'Ajankohtaista',
        '/haluan_sertifikaatin': 'Lähetä hakemus',
        '/loyda_ammattilainen': 'Etsi ammattilainen',
        '/ota_yhteytta': 'Yhteystiedot',
        '/patevyydet': 'Pätevyydet',
        '/sertifikaatit': 'Sertifikaatit',
      };

      let title = state.latestPageTitle;
      for (const k in map) {
        if (path.indexOf(k) === 0) { title = map[k]; break; }
      }

      return {
        ...state,
        breadcrumbItems: title ? [BASE()] : state.breadcrumbItems,
        latestPageTitle: title,
        nextRouteLocationPathname: path,
      };
  }
    case actionTypes.BREADCRUMB_CHANGED_ON_NEWS_PAGE:
      return {
        ...state,
        breadcrumbItems: [BASE(), { id: '2', title: 'Ajankohtaista', navigationUrl: '/ajankohtaista' },],
        latestPageTitle: String(action.payload),
      };

    case actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE:
    case actionTypes.BREADCRUMB_CHANGED_ON_NEWS_LIST_PAGE:
    case actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_PAGE:
    case actionTypes.BREADCRUMB_CHANGED_ON_COMPETENCES_PAGE:{
      const incoming = (typeof action.payload === 'string') ? action.payload : ((action.payload && action.payload.title) || '');
      const newTitle = incoming && incoming.trim().length > 0 ? incoming : state.latestPageTitle;

      return {
        ...state,
        breadcrumbItems: [BASE()],
        latestPageTitle: newTitle,
      };
  }

    case actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_CONTENT_PAGE:
    case actionTypes.BREADCRUMB_CHANGED_ON_COMPETENCES_CONTENT_PAGE: {
      if (isBreadcrumbsPath(action.payload) && (action.payload as any).id) {
        const p = action.payload as BreadcrumbsPath;
        return {
          ...state,
          breadcrumbItems: buildPathList(p),
          latestPageTitle: (p && p.latestPageTitle) != null ? p.latestPageTitle : ((p && (p as any).title) || ''),
        };
      } else {
        const pl = action.payload;
        const incoming = typeof pl === 'string' ? pl : ((pl && pl.title) || '');
        const newTitle = incoming && incoming.trim().length > 0 ? incoming : state.latestPageTitle;

        return {
          ...state,
          breadcrumbItems: [BASE()],
          latestPageTitle: newTitle,
        };
      }
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/breadcrumb.ts